/* eslint-disable import/first */
import $ from 'jquery';
import 'slick-carousel/slick/slick.min.js';
const Vivus = require('vivus');
import viewportUnitsBuggyfill from 'viewport-units-buggyfill';
import gsap from 'gsap';
import Splitting from 'splitting';
import {ua} from './ua';

// responsiveFlag
var flag = false;
$(window).on('load resize', function() {
	flag = ( window.matchMedia('(max-width:991px)').matches );
} );

export const jqueryProcess = () => {
	viewportUnitsBuggyfill.init();// iOSのvhをFixするモジュール

	wrapperFixed('on');

	// デバイス判定
	const user = ua();
	if(user.type === 'mobile'){
		$('body').addClass('device-mobile');
	} else if (user.type === 'tablet') {
		$('body').addClass('device-tablet');
	} else {
		$('body').addClass('device-desktop');
	}

	// split
	const target = document.querySelectorAll('.visual_text .text');
	Splitting({
		target: target,
		by: 'chars'
	});

	// .l-header fixed
	var $header = $('.l-header');
	$(window).on('load scroll', function() {
		var value = $(this).scrollTop();
		if ( value > 200 ) {
			$header.addClass('fixed');
		} else {
			$header.removeClass('fixed');
		}
	});

	// .header-toggle click
	$('.header-toggle').click(function(){
		$('.header-wrap').toggleClass('open');
	});

	$('.header-nav-link').click(function(){
		$('.header-wrap').removeClass('open');
	});

	// .numbers_viewmore
	$('.numbers_viewmore_btn').click(function(){
		$(this).addClass('is-hidden');
		$('.numbers_viewmore_content').toggleClass('open');
	});

	// interview
	$('.interview_slick').slick({
		speed: 1000,
		slideToShow: 3,
		slideToScroll: 1,
		variableWidth: true,
		centerMode: true,
		prevArrow:'<div class="slick-prev"></div>',
		nextArrow:'<div class="slick-next"></div>',
		responsive: [{
			breakpoint: 990,
			settings: {
				arrows: false,
				slideToShow: 1,
				centerPadding: '60px'
			}
		}]
	});

	// .scroll
	var scrollElm = (function() {
		if('scrollingElement' in document) {
		return document.scrollingElement;
		}
		if(navigator.userAgent.indexOf('WebKit') !== -1) {
		return document.body;
		}
		return document.documentElement;
	})();

	$('a[href^="#"]').not('.noscroll').on('click', function() {
		var headerHight = 60;
		if (flag) {
			headerHight = 60;
		} else {
			headerHight = 80;
		}
		var speed = 1000;
		var easing = 'swing';
		var href= $(this).attr("href");
		$(scrollElm).animate({
		scrollTop: $(href === "#" ? 'html' : href).offset().top-headerHight
		}, speed, easing);
		return false;
	});

	var mql = window.matchMedia('screen and (max-width: 1199px)');
	function checkBreakPoint(mql) {
		if (mql.matches) {// lg down
		} else {// xl up
			$('.header-wrap').removeClass('open');
		}
	}
	mql.addListener(checkBreakPoint);
	checkBreakPoint(mql);

	// scroll to top
	let topscroll = document.querySelector('.topscroll')
	document.addEventListener('scroll', () => {
		let flowEl = document.querySelector('#flow')
		let recruitmentsEl = document.querySelector('#recruitments')

		if(window.scrollY >= (flowEl.offsetTop - flowEl.offsetHeight)) {
		topscroll.style.opacity = 1
		topscroll.style.bottom = '25px'
		if(window.scrollY >= (recruitmentsEl.offsetTop - recruitmentsEl.offsetHeight)) {
			topscroll.querySelector('svg').style.fill = 'white'
		} else {
			topscroll.querySelector('svg').style.fill = '#111'
		}
		} else {
		topscroll.style.opacity = 0
		topscroll.style.bottom = '-20px'
		}
	}, false)
}

$(window).on('load', function () {
	$('#load').addClass('is-start');

	setTimeout(function(){
		$('#mainvisual .visual_text').css({
			'display': 'block',
		});
		wrapperFixed('off');
		gsap.fromTo('.visual_text .text .char', {
			y: 40,
			opacity: 0,
		}, {
			y: 0,
			opacity: 1,
			duration: .4,
			stagger: .05,
			ease: 'power1'
		});
	},3000);
	setTimeout(function(){
		$('#load').remove();
	},3000);

	const logoSVGline = new Vivus('logo-mark-line',{
		type: 'delayed',
		// start: 'autostart',
		dashGap: 10,
		forceRender: false,
		duration: 100,
		reversStack: true
	});
	logoSVGline.play(1,function(){
		// called after the animation completes
	});

	// slick
	$('.visual_image_first').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1500,
		arrows: false,
		infinite: true,
		draggable: false,
		pauseOnFocus: false,
		swipe: false,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});
	$('.visual_image_second').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1500,
		arrows: false,
		infinite: true,
		draggable: false,
		pauseOnFocus: false,
		swipe: false,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});
	$('.visual_image_third').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1500,
		arrows: false,
		infinite: true,
		draggable: false,
		pauseOnFocus: false,
		swipe: false,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});
});

function wrapperFixed(state) {
	var scrollBarWidth = window.innerWidth - $(window).width();
	var pos;
	if(state === 'on') {
		pos = $(window).scrollTop();
		$('.l-header').css({
			'padding-right': scrollBarWidth + 'px',
		});
		$('body').css({
			'position': 'fixed',
			'top': '-' + pos + 'px',
			'width': '100%',
			'height': '100%',
			'padding-right': scrollBarWidth + 'px',
		});
		$('body').addClass('is-fixed');
	} else if(state === 'off') {
		pos = parseInt($('body').css('top').replace(/-/g,'').replace(/px/g,''));
		$('.l-header').css({
			'padding-right': '',
		});
		$('body').css({
			'position': '',
			'top': '',
			'width': '',
			'height': '',
			'padding-right': '',
		});
		$('body').removeClass('is-fixed');
		$(window).scrollTop(pos);
	}
}


// WEBPACK FOOTER //
// ./src/externals/common.js